import axios from 'axios';
import qs from 'qs';
import { OnavPositionListResponse } from '../interfaces/onavPosition';
import { Params } from '../interfaces/params';

const { REACT_APP_API_URL } = process.env;

type OnavPositionsParams = Params & {
  query?: object;
  token?: string | null;
};

export const onavPositions = async ({
  search,
  page,
  pageSize = 300,
  query: customQuery = {},
}: OnavPositionsParams = {}) => {
  const query = {
    pagination: {
      page,
      pageSize,
    },
    sort: 'name:asc',
    filters: search ? { name: { $contains: search } } : undefined,
    ...customQuery,
  };

  const { data } = await axios.get<OnavPositionListResponse>(
    `${REACT_APP_API_URL}/onav-positions?${qs.stringify(query, {
      skipNulls: true,
    })}`
  );
  return data;
};

export const find = async ({
  token,
  query,
}: {
  token: string | null;
  query: object;
}) => {
  const { data } = await axios.get<OnavPositionListResponse>(
    `${REACT_APP_API_URL}/onav-positions?${qs.stringify(query)}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};

const onavPosition = { find };

export default onavPosition;
